// 어느 지인에듀 사이트로 로그인하나: "english" | "math"(2026-10-06).
// 수학 사이트의 '온라인 출제' 버튼은 /?site=math 로 들어온다. 그 값을 기억했다가 로그인 주소를 받을 때 서버에 넘긴다.
// 화면은 하나를 같이 쓰고, 수학 계정이면 영어 문제지 메뉴만 숨긴다(pages/HomePage.jsx). 서버: api/user/sites.py
const LOGIN_SITE_KEY = "login_site";
// 이번 방문에 주소로 사이트를 고르고 들어왔는가. 이미 다른 사이트 계정으로 로그인해 있으면 다시 로그인시킨다
const REQUESTED_SITE_KEY = "requested_site";
const SITE_LIST = ["english", "math"];

const safeGet = (storage, key) => {
  try {
    return storage.getItem(key);
  } catch (error) {
    return null;
  }
};

const safeSet = (storage, key, value) => {
  try {
    if (value === null) storage.removeItem(key);
    else storage.setItem(key, value);
  } catch (error) {
    // 저장소를 못 쓰는 브라우저면 영어로 로그인한다
  }
};

export const rememberSiteFromUrl = () => {
  const site = new URLSearchParams(window.location.search).get("site");
  if (!SITE_LIST.includes(site)) return;
  safeSet(localStorage, LOGIN_SITE_KEY, site);
  safeSet(sessionStorage, REQUESTED_SITE_KEY, site);
};

export const getLoginSite = () => {
  const site = safeGet(localStorage, LOGIN_SITE_KEY);
  return SITE_LIST.includes(site) ? site : "english";
};

// 주소로 고른 사이트와 지금 로그인한 계정의 사이트가 다르면 그 사이트 이름을, 아니면 null
export const takeSiteMismatch = (userSite) => {
  const requested = safeGet(sessionStorage, REQUESTED_SITE_KEY);
  safeSet(sessionStorage, REQUESTED_SITE_KEY, null);
  if (!SITE_LIST.includes(requested)) return null;
  return requested !== (userSite || "english") ? requested : null;
};
